import {Component, OnInit} from '@angular/core';
import {View} from './overview/view';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  start = true;
  currentBackground: string;

  ngOnInit(): void {
    this.setCurrentBackground('start.jpg');
  }

  changeBackground(view: View): void {
    if (view === 'overview') {
      this.setCurrentBackground('start.jpg');
    } else {
      this.setCurrentBackground(`${view}.jpg`);
    }
  }

  private setCurrentBackground(file: string): void {
    this.currentBackground = `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('assets/img/backgrounds/${file}')`;
  }
}
